import axios from "axios";

const apiAuth = axios.create({
    withCredentials: true,
    baseURL: process.env.VUE_APP_API_URL,
});

export function loginApi(data) {
    return apiAuth.post('/auth/login', data)
}

export function getFormSignUpApi() {
    return apiAuth.get(`/auth/sign-up`)
}

export function signUpApi(data) {
    return apiAuth.post('/auth/register', data)
}


export function resetPasswordApi(data) {
    return apiAuth.post('/password/reset-request', data)
}

export function newPasswordApi(data) {
    return apiAuth.post(`/password/reset`, data)
}

export function checkTokenPasswordApi(token) {
    return apiAuth.get(`/password/reset-tokens/validate/${token}`)
}

export async function logoutApi() {
    return apiAuth.post('/auth/token/invalidate');
}
